/**
 *
 */
export function playerActionsSelector(state) {
    return state.actions;
}
/**
 *
 */
export function liveStreamActionsSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreamActions[liveStreamId];
}
/**
 *
 */
export function audienceTokenSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreams[liveStreamId]?.provider_info?.token;
}
/**
 *
 */
export function uidSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreams[liveStreamId]?.provider_info?.uid;
}
/**
 * Get list of livestream's active streamers
 * @param state
 * @param liveStreamId
 */
export function activeStreamersSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreams[liveStreamId]?.provider_info?.active_streamers;
}
/**
 * This selector should only be used by the product hooks. To get the correct
 * video products merged with hydrated products, use one of the product hooks.
 * @return Undefined if video products are not loaded, otherwise a list of video
 *     products. Note that the list can be empty indicating that no products are
 *     available for the video.
 */
export function hookOnlyVideoProductsSelector(state, videoId) {
    if (!videoId) {
        return;
    }
    return state.videoProducts[videoId];
}
/**
 * This selector should only be used by the product hooks. To get the correct
 * live stream products merged with hydrated products, use one of the product
 * hooks.
 */
export function hookOnlyLiveStreamProductsSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreamProducts[liveStreamId];
}
/**
 *
 */
export function hasHydratedProductsSelector(state, videoId) {
    if (!videoId) {
        return false;
    }
    return !!state.hasHydratedProducts[videoId];
}
/**
 * Selector to get video's livestream object
 */
export function liveStreamSelector(video) {
    return function (state) {
        if (video?.live_stream_id) {
            return state.liveStreams[video.live_stream_id];
        }
    };
}
/**
 * Selector for livestream announcement to use on running banner
 */
export function liveStreamRunningAnnouncementSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreamRunningAnnouncements[liveStreamId];
}
/**
 * Selector to fetch livestream messages
 */
export function liveStreamMessagesSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreamMessages[liveStreamId];
}
/**
 * Selector to fetch livestream bot greeting flag
 */
export function liveStreamBotGreetingSelector(state, liveStreamId) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreamBotGreeting[liveStreamId];
}
/**
 * Selector for livestream message by username
 */
export function liveStreamMessagesByUserSelector(state, liveStreamId, username) {
    if (!liveStreamId) {
        return;
    }
    return state.liveStreamMessages[liveStreamId]?.filter((message) => message.username === username);
}
/**
 *
 */
export function currentLiveStreamIdSelector(state) {
    return state.video?.live_stream_id;
}
/**

 */
export function liveStreamInteractionsSelector(state, liveStreamId, type) {
    if (!liveStreamId) {
        return;
    }
    const allInteractions = state.liveStreams[liveStreamId]?.interactions;
    if (!allInteractions) {
        return [];
    }
    if (!type) {
        return allInteractions;
    }
    return allInteractions.filter((interaction) => interaction.interaction_type === type);
}
/** */
export function liveStreamInteractionSelector(state, liveStreamId, interactionId) {
    if (!liveStreamId || !interactionId) {
        return;
    }
    return state.liveStreams[liveStreamId]?.interactions?.find((interaction) => interaction.id === interactionId);
}
/**

 */
export function highlightedEntitiesSelector(state, liveStreamId, entityType) {
    if (!liveStreamId) {
        return;
    }
    const allEntities = state.liveStreams[liveStreamId]?.highlighted_entities;
    if (!allEntities) {
        return [];
    }
    if (!entityType) {
        return allEntities;
    }
    return allEntities.filter((entity) => entity.entity_type === entityType);
}
